// Regexp for spaces and &nbsp
const regexpToReplace = /\s|&nbsp;/g;

export const formatAttribute = (string) => {
	try {
		return string.replaceAll(regexpToReplace, '').toLowerCase();
	} catch {
		return string;
	}
};

export const DIRECTIVE_NAME = 'qa';

const setDataQA = (element, binding) => {
	// eslint-disable-next-line no-param-reassign
	element.dataset.qa = formatAttribute(binding.value);
};

export const dataQADirective = {
	bind: (element, binding) => setDataQA(element, binding),
	update: (element, binding) => setDataQA(element, binding),
};
